(function () {
  function initHeader(section) {
    const header = section.querySelector('[data-section-type="header"]');
    if (!header) return;

    // === Mobile menu toggle ===
    const burgerWrapper = header.querySelector('.site-header__burger-wrapper');
    const burger = header.querySelector('[data-menu-toggle]');
    const mobileNav = header.querySelector('.site-header__mobile-nav');

    const openMenu = () => {
      if (!burger || !mobileNav) return;
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', 'Close menu');
      mobileNav.dataset.open = 'true';
      mobileNav.hidden = false;
      document.body.style.overflow = 'hidden';
    };

    const closeMenu = () => {
      if (!burger || !mobileNav) return;
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Open menu');
      mobileNav.dataset.open = 'false';
      document.body.style.overflow = '';
    };

    const toggleMenu = () => {
      const isOpen = burger.getAttribute('aria-expanded') === 'true';
      if (isOpen) closeMenu();
      else openMenu();
    };

    if (burgerWrapper && burger && mobileNav) {
      burgerWrapper.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleMenu();
      });

      mobileNav.addEventListener('click', (e) => {
        e.stopPropagation();
      });

      document.addEventListener('click', (e) => {
        const isOpen = burger.getAttribute('aria-expanded') === 'true';
        if (!isOpen) return;
        if (header.contains(e.target)) return;
        closeMenu();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
          closeMenu();
          burger.focus();
        }
      });
    }

    // === Mobile submenu accordion ===
    header.querySelectorAll('[data-submenu-toggle]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const open = btn.getAttribute('aria-expanded') === 'true';
        const submenu = btn
          .closest('.site-header__mobile-item')
          .querySelector('.site-header__mobile-submenu');
        btn.setAttribute('aria-expanded', String(!open));
        if (submenu) submenu.hidden = open;
      });
    });

    // === Search toggle ===
    const searchToggle = header.querySelector('[data-search-toggle]');
    const searchDrawer = header.querySelector('[data-search-drawer]');
    const searchClose = header.querySelector('[data-search-close]');

    if (searchToggle && searchDrawer) {
      searchToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const isHidden = searchDrawer.hidden;
        searchDrawer.hidden = !isHidden;
        if (isHidden) {
          const input = searchDrawer.querySelector('input');
          if (input) input.focus();
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      });

      if (searchClose) {
        searchClose.addEventListener('click', () => {
          searchDrawer.hidden = true;
          document.body.style.overflow = '';
        });
      }

      searchDrawer.addEventListener('click', (e) => {
        e.stopPropagation();
      });

      document.addEventListener('click', (e) => {
        if (searchDrawer.hidden) return;
        if (header.contains(e.target)) return;
        searchDrawer.hidden = true;
        document.body.style.overflow = '';
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !searchDrawer.hidden) {
          searchDrawer.hidden = true;
          document.body.style.overflow = '';
          searchToggle.focus();
        }
      });
    }

    // === Transparent header on scroll ===
    if (header.classList.contains('site-header--transparent')) {
      const onScroll = () => {
        header.classList.toggle('is-scrolled', window.scrollY > 50);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // === Close mobile menu on resize to desktop ===
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth >= 990) {
          closeMenu();
        }
      }, 150);
    });
  }

  // === TOP BAR INIT - ADD THIS ===
  function initTopBar() {
    const sectionId = document.querySelector('[data-section-type="header"]')?.dataset.sectionId;
    if (!sectionId) return;

    // Check if top bar was previously closed
    const hiddenKey = `ds-top-bar-${sectionId}-hidden`;
    if (sessionStorage.getItem(hiddenKey) === 'true') {
      const topBar = document.querySelector('.header-top');
      if (topBar) topBar.style.display = 'none';
      document.body.classList.add('ds-top-bar-closed');
    }

    // Init countdown if exists
    const countdownEl = document.getElementById(`ds-top-bar-countdown-${sectionId}`);
    if (countdownEl && typeof window[`dsTopBarStartCountdown_${sectionId.replace(/-/g, '_')}`] === 'function') {
      window[`dsTopBarStartCountdown_${sectionId.replace(/-/g, '_')}`]();
    }
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('[data-section-type="header"]')
      .forEach((el) => initHeader(el.closest('.shopify-section') || el.parentElement));
    
    initTopBar(); // Init top bar
  });

  // === Shopify theme editor lifecycle ===
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-section-type="header"]')) {
      initHeader(e.target);
      initTopBar();
    }
  });

  document.addEventListener('shopify:section:unload', () => {
    document.body.style.overflow = '';
  });

  document.addEventListener('shopify:section:select', (e) => {
    const header = e.target.querySelector('[data-section-type="header"]');
    if (!header) return;
    initHeader(e.target);
  });
})();